import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'checkpointType.update.error': {
    defaultMessage: 'Failed to update checkpoint type',
    id: 'checkpointType.update.error'
  },
  'checkpointType.update.pageTitle': {
    defaultMessage: 'Update Checkpoint Type',
    id: 'checkpointType.update.pageTitle'
  },
  'checkpointType.update.success': {
    defaultMessage: 'Updated checkpoint type',
    id: 'checkpointType.update.success'
  }
});
